import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import { Camera, X } from 'lucide-react';

const MomentsGallery = () => {
  const { API } = useContext(AuthContext);
  const [moments, setMoments] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    axios.get(`${API}/gallery/moments?limit=10`)
      .then((res) => setMoments(res.data.moments || []))
      .catch(() => setMoments([]));
  }, [API]);

  if (moments.length === 0) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 pt-10" dir="rtl" data-testid="moments-gallery">
      <div className="flex items-center gap-2 mb-4">
        <Camera className="w-5 h-5 text-purple-600" />
        <h3 className="font-extrabold text-gray-800 text-xl">📸 רגעים מהמגרש</h3>
        <span className="text-xs text-gray-400">התמונות האחרונות מהתחרויות</span>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-3" style={{ scrollbarWidth: 'thin' }}>
        {moments.map((m, i) => (
          <button
            key={i}
            onClick={() => setLightbox(m)}
            data-testid={`moment-${i}`}
            className="relative shrink-0 w-44 h-56 rounded-2xl overflow-hidden group shadow-md hover:shadow-xl transition-shadow"
          >
            <img src={m.url} alt={m.tournament_name} loading="lazy" className="w-full h-full object-cover transition-transform group-hover:scale-105" />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-2.5 pt-8 text-right">
              <p className="text-white text-xs font-bold truncate">{m.tournament_name}</p>
              {m.tournament_date && <p className="text-white/60 text-[10px]">{new Date(m.tournament_date).toLocaleDateString('he-IL', { day: 'numeric', month: 'short' })}</p>}
            </div>
          </button>
        ))}
      </div>

      {lightbox && (
        <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4" onClick={() => setLightbox(null)} data-testid="moment-lightbox">
          <button className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20" onClick={() => setLightbox(null)}>
            <X className="w-6 h-6" />
          </button>
          <div className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={lightbox.url} alt={lightbox.tournament_name} className="w-full max-h-[75vh] object-contain rounded-xl" />
            <div className="flex items-center justify-between mt-3 text-white">
              <span className="font-bold">{lightbox.tournament_name}</span>
              <Link to={`/tournament/${lightbox.tournament_id}`} className="text-emerald-400 text-sm font-bold hover:underline" onClick={() => setLightbox(null)}>
                ← לעמוד התחרות
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MomentsGallery;
